const ProfileData = {
  img: require("../assets/Images/hero.png"),
  
  name: "Sanjana Mutkiri",
  professions: ["Web Developer", "Problem Solver", "Tech Enthusiastic"],
  info: [
    "Knack of building web applications using MERN stack.",
    "I enjoy designing tech websites.",
  ],
  resume:
    "https://drive.google.com/file/d/1zjYBd0mrb61U48bZ7ZMooVUrjALMf8Yp/view?usp=sharing",
};

export default ProfileData;
